module.exports = __webpack_public_path__ + "static/media/icon-logo.405f4509.svg";